// Modules
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

// Components
import { Spinner } from '@/ui';
import { StyledLayout } from './MainLayoutStyles';
import MainLayoutContent from '../MainLayoutContent/MainLayoutContent';
import SentryTestButton from '../../components/SentryTestButton/SentryTestButton';

// Models
import DesktopSideBar from '../DesktopSideBar/DesktopSideBar';

const MainLayout = () => {
  return (
    <StyledLayout>
      <DesktopSideBar />
      <MainLayoutContent>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </MainLayoutContent>
      <SentryTestButton />
    </StyledLayout>
  );
};

export default MainLayout;
